import {API, handleApiError} from "./utils";

const path = "organisations";

export const fetchOrganisationsNameAndId = async (userId) => {
  try {
    const res = await API.get(`/${path}/fetch-organisations?userId=${userId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchSingleOrganisation = async (organisationId) => {
  try {
    const res = await API.get(`/${path}/fetch-single-organisation?organisationId=${organisationId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyAndSaveDomain = async (domain, organisationId) => {
  try {
    return await API.post(`/${path}/verify-save-domain`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {domain, organisationId},
    })
  } catch (error) {
    return null
  }
}

export const updateOrganizationSettings = async (organisationId, settings) => {
  try {
    // If settings is an array (legacy: loyaltyBaseRates), wrap it
    // Otherwise, use the settings object directly
    const settingsPayload = Array.isArray(settings) 
      ? { loyaltyBaseRates: settings }
      : settings;
    
    const response = await API.post(`/${path}/update-settings`, {
      organisationId,
      settings: settingsPayload
    });
    
    return { error: null, data: response.data };
  } catch (error) {
    console.error('Error updating organization settings:', error);
    return handleApiError(error);
  }
};
